import classNames from 'classnames';
import styles from './HeroCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';

export interface HeroCardProps {
	className?: string;
	link?: {
		url: string;
		name?: string;
		target?: string;
	};
	kicker?: string;
	heading: string;
	text?: string;
	image?: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
	};
	altText?: string;
	player?: React.ReactNode;
	layout?: 'Small Media' | 'Full Width Center';
	searchInput?: React.ReactNode;
	id?: string;
}

export const UI_HeroCard = ({ heading, link, kicker, text, image, altText, className, player, layout, searchInput, id }: HeroCardProps) => {
	const layoutCamelCase = layout?.replace(/\s+/g, '').replace(/^./, (str) => str.toLowerCase());

	return (
		<header className={classNames(styles.HeroCard, styles[`HeroCard___${layoutCamelCase}`], className)}>
			<div className={styles.HeroCard_containerWrapper}>
				{layout === 'Full Width Center' && (image?.url || player) && (
					<div className={styles.HeroCard_backgroundMedia}>
						{player
							? player
							: image?.url && <UI_Picture {...image} altText={altText} sizes="100vw" fetchpriority="high" lazyload={false} />}
					</div>
				)}
				<UI_Container width="Standard" className={styles.HeroCard_container}>
					<div className={styles.HeroCard_wrapper}>
						<div className={styles.HeroCard_textbox}>
							<div className={styles.HeroCard_textboxInner}>
								{kicker && <div className={styles.HeroCard_kicker}>{kicker}</div>}
								<UI_Heading headingLevel="h1" style="xl50" className={styles.HeroCard_heading} id={id}>
									{heading}
								</UI_Heading>
								{text && <UI_Paragraph className={styles.HeroCard_text}>{text}</UI_Paragraph>}
								{searchInput ? (
									<div className={styles.HeroCard_searchInput}>{searchInput}</div>
								) : (
									link &&
									link.name && (
										<UI_LinkButton className={styles.HeroCard_linkButton} style="tertiary" aria-label={link?.name} {...link}>
											{link?.name}
										</UI_LinkButton>
									)
								)}
							</div>
						</div>
						{layout !== 'Full Width Center' && (player || image?.url) && (
							<div className={styles.HeroCard_mediaContainer}>
								{player ? (
									<div className={styles.HeroCard_video}>{player}</div>
								) : (
									image.url && (
										<div className={styles.HeroCard_image}>
											<UI_Picture
												className={styles.HeroCard_imageElement}
												{...image}
												altText={altText}
												sizes="(min-width: 768px) 50vw, 100vw"
												fetchpriority="high"
												lazyload={false}
											/>
										</div>
									)
								)}
							</div>
						)}
					</div>
				</UI_Container>
			</div>
		</header>
	);
};
